/**
 * updateMultipleFormValues
 *
 * This function updates multiple form values in a form state using a provided 'setValue' function.
 * It accepts a variable number of form values objects, merges them into a single object,
 * and then iterates over the merged object to update each form value where the value is not null.
 *
 * @param {Function} setValue - The function used to update the form values from React Hook Form
 * @param {...Object} formValuesList - Any number of form values objects to be merged and updated
 *
 * Example usage:
 *
 * updateMultipleFormValues(
 *   setValue,
 *   resetAddressFields(1),
 *   resetAddressFields(2),
 *   {
 *     company_number: '',
 *     company_name: '',
 *     company_vat_number: '',
 *   }
 * );
 */

const updateMultipleFormValues = (setValue, ...formValuesList) => {
  const mergedFormValues = formValuesList.reduce(
    (acc, formValues) => ({ ...acc, ...formValues }),
    {},
  );

  Object.entries(mergedFormValues).forEach(([key, value]) => {
    if (value !== null) {
      setValue(key, value);
    }
  });
};

export default updateMultipleFormValues;
